export default "__VITE_ASSET__DZwo35rX__"